module.exports = __webpack_public_path__ + "img/facebook.c6e8459b.svg";